import { NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CandidateScoreRating } from 'src/app/shared/models/enums/candidate-score-rating.enum';

@UntilDestroy()
@Component({
    selector: 'nova-rating-name',
    templateUrl: './rating-name.component.html',
    styleUrls: ['./rating-name.component.scss'],
    standalone: true,
    imports: [NgOptimizedImage]
})
export class RatingNameComponent {
    @Input() ratingId: CandidateScoreRating;
    @Input() name: string = '';
    @Input() showName: boolean = true;

    CandidateScoreRating = CandidateScoreRating;
}
